module.exports = __webpack_public_path__ + "img/paloma.1d8963f3.svg";